<template>
  <div>
    <SubscriberID v-on:closeSubscribe="closeSubscribe" v-on:verifySubscribe="verifySubscribe" v-if="subscriberStatus.isShow" />

    <div id="BooksInner" class="BooksInner w-full text-NotoSansRegular" v-if="dataList !== null" ref="BooksInner">
      <Breadcrumb :productTitle="dataList" :category_type="category_type" />
      <div class="main mb-4 md:mb-6 mx-auto">
        <div class="flex mb-2 mb-lg-3 flex-wrap">
          <div class="w-full md:w-2/5 mb-4 md:mb-0">
            <Gallery :coverList="previewList" v-if="previewList && previewList.length > 0" :is_digital="dataList.is_digital" :category_id="dataList.category_id" />
          </div>
          <div class="w-full md:w-3/5 md:pl-4 lg:pl-8">
            <div class="flex flex-col w-full justify-between h-full">
              <div class="main-detail">
                <div class="SubscriptionPlan flex flex-col md:flex-row md:items-center mb-3 pt-2" v-if="dataType === 'PLAN' && dataList.category_id">
                  <div class="magazineLogo md:mr-2 flex justify-center md:justify-start w-auto md:w-40">
                    <img class="w-full h-full object-contain" src="~@/assets/logo/logo_abc.png" alt="livaABC" v-if="dataList.category_id === 123">
                    <img class="w-full h-full object-contain" src="~@/assets/logo/logo_live.png" alt="livaABC" v-if="dataList.category_id === 124">
                    <img class="w-full h-full object-contain" src="~@/assets/logo/logo_all.png" alt="livaABC" v-if="dataList.category_id === 125">
                    <img class="w-full h-full object-contain" src="~@/assets/logo/logo_cnn.png" alt="livaABC" v-if="dataList.category_id === 126">
                    <img class="w-full h-full object-contain" src="~@/assets/logo/logo_jp.png" alt="livaABC" v-if="dataList.category_id === 122">
                    <img class="w-full h-full object-contain" src="~@/assets/logo/logo_hiw.png" alt="livaABC" v-if="dataList.category_id === 121">
                  </div>
                  <div class="flex flex-wrap justify-center md:justify-start">
                    <h4 class="m-0 text-2xl text-center md:text-left text-NotoSansBold">{{ dataList.edition }}&nbsp;</h4>
                    <h4 class="m-0 text-2xl text-center md:text-left text-NotoSansBold">訂閱方案</h4>
                  </div>
                </div>

                <div class="px-2 md:px-0">
                  <div class="flex flex-wrap">
                    <p v-if="dataType !== 'PLAN' && dataList.serial_no" class="mr-2 textColorgray">{{ dataList.serial_no }}</p>
                    <div class="label-grop flex flex-wrap" v-if="((downloadFiles.lifePenFile && downloadFiles.lifePenFile.length > 0) || (downloadFiles.myVoiceFile && downloadFiles.myVoiceFile.length > 0)) || dataList.name.indexOf('口袋書') > 0">
                      <div class="label-item text-NotoSansRegular rounded-full border px-2 mr-2 textColorgray borderColorgray"
                        v-if="(downloadFiles.lifePenFile && downloadFiles.lifePenFile.length > 0) || (downloadFiles.myVoiceFile && downloadFiles.myVoiceFile.length > 0)">
                        <h5>可點讀</h5>
                      </div>
                      <div class="label-item text-NotoSansRegular rounded-full border px-2 mr-2 textColorgray borderColorgray"
                        v-if="dataList.name.indexOf('口袋書') > 0 && dataType !== 'PLAN' && dataType !== 'MAGAZINE'">
                        <h5>口袋書</h5>
                      </div>
                    </div>
                  </div>
                  <div class="SubscriptionPlan flex items-center mb-2" v-if="dataType !== 'PLAN'">
                    <h1 class="m-0 text-xl lg:text-2xl text-NotoSansBold font-bold tracking-wider">{{ dataList.name }}</h1>
                  </div>
                  <div class="SubscriptionDetail">
                    <!-- <div class="label-grop flex flex-wrap mb-2" v-if="((downloadFiles.lifePenFile && downloadFiles.lifePenFile.length > 0) || (downloadFiles.myVoiceFile && downloadFiles.myVoiceFile.length > 0)) || dataList.name.indexOf('口袋書') > 0">
                      <div class="label-item text-NotoSansRegular rounded-full border px-2 mr-2 textColorgray borderColorgray"
                        v-if="(downloadFiles.lifePenFile && downloadFiles.lifePenFile.length > 0) || (downloadFiles.myVoiceFile && downloadFiles.myVoiceFile.length > 0)">
                        <h5>可點讀</h5>
                      </div>
                      <div class="label-item text-NotoSansRegular rounded-full border px-2 mr-2 textColorgray borderColorgray"
                        v-if="dataList.name.indexOf('口袋書') > 0 && dataType !== 'PLAN' && dataType !== 'MAGAZINE'">
                        <h5>口袋書</h5>
                      </div>
                    </div> -->
                    <div class="activity flex mt-1 mb-2 border-l-2 borderOrange flex-col" v-if="(all_events || dataList.event) && dataList.status !== 'DISCONTINUED'">
                      <!-- 絕版不顯示 -->
                      <ul v-if="all_events && dataList.event && dataList.event.is_exclude === 0" class="ml-2">
                        <li v-for="(item, index) in all_events" :key="index" class="flex textColorRed text-NotoSansLight">
                          <router-link :to="{ name: 'sale', params: { category: $route.params.category }, query: { tag: item.id } }" class="flex">
                            <p class="m-0 font-normal text-sm"><span>全館‧</span>{{ item.name }}</p>
                          </router-link>
                        </li>
                      </ul>
                      <ul v-if="dataList.event" class="ml-2">
                        <li class="flex textColorRed text-NotoSansLight">
                          <router-link :to="{ name: 'sale', params: { category: $route.params.category }, query: { tag: dataList.event.id } }" class="flex">
                            <p class="m-0 font-normal text-sm"><span>商品‧</span>{{ dataList.event.name }}</p>
                          </router-link>
                        </li>
                      </ul>
                    </div>

                    <h5 class="category font-normal text-NotoSansRegular mt-3" v-if="category_type">類別：
                      <router-link :to="{ name: 'productsList', params:{ category: category_type }, query: { type: dataList.type, category: dataList.category_id } }" class="hover:underline">
                      <span>{{ dataList.category_name }}</span></router-link>
                    </h5>

                    <h5 class="contents font-normal text-NotoSansRegular flex" v-if="dataList.contents">
                      <span class="whitespace-no-wrap">內容：</span>
                      <span>{{ dataList.contents }}</span>
                    </h5>
                    <!-- <h5 v-if="dataType === 'PLAN'" class="leading-normal border p-2 textColorRed borderRed">
                      自111年10月號起，訂閱或購買英日語雜誌將不再附贈朗讀CD光碟片，可使用『QR-CODE網站』或『至官網下載』等更便利的方式聆聽MP3。
                      <mark class="warning">響應環保的你，若不需要朗讀CD光碟片，請在訂單「備註事項」說明讓我們知道喔！</mark>
                      </h5> -->
                    <h5 class="specification font-normal text-NotoSansRegular" v-if="dataList.specification">規格：
                      <span>{{ dataList.specification }}</span>
                    </h5>
                    <h5 class="ISBN font-normal text-NotoSansRegular" v-if="(dataType === 'ITEM' || dataType === 'BOOK') && dataList.ISBN">ISBN：
                      <span>{{ dataList.ISBN }}</span>
                    </h5>
                    <div class="periods flex flex-nowrap text-NotoSansRegular my-2" v-if="dataType === 'PLAN' && dataList.plan && dataList.plan.length > 0">
                      <h5 class="whitespace-no-wrap">期數：</h5>
                      <div class="w-full px-3 md:px-0">
                        <div class="relative">
                          <select v-model="selectedPlan" @change="getEndTime" class="text-sm block appearance-none w-full border border-gray-500 text-gray-700 py-2 px-8 pr-12 rounded leading-tight focus:outline-none bg-white focus:border-gray-500"
                            id="selected-period">
                            <option :value="item" v-for="(item, index) in dataList.plan" :key="index">{{ item.name }}</option>
                          </select>
                          <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                            <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="startEndTime flex flex-nowrap text-NotoSansRegular my-2 md:mb-4" v-if="dataType === 'PLAN'">
                      <h5 class="whitespace-no-wrap">起訖：</h5>
                      <div class="peirod flex flex-no-wrap px-3 lg:px-0">
                        <div class="startTime flex">
                          <date-picker v-model="begin_at" valueType="format" type="month" placeholder="請選擇" @change="getEndTime" :disabled-date="disabledDate" :input-class="'input-class'"></date-picker>
                        </div>
                        <div class="flex items-center justify-center"  style="width: 8%;">
                          <p class="">~</p>
                        </div>
                        <div class="endTime flex">
                          <input v-model="end_at" readonly class="w-full appearance-none rounded px-2 focus:outline-none text-sm" id="grid-password" type="text" placeholder="">
                        </div>
                      </div>
                    </div>

                    <h5 class="published_at whitespace-no-wrap font-normal text-NotoSansRegular" v-if="dataType === 'BOOK' || dataType === 'MAGAZINE'">出版日期：
                      <span>{{ moment(dataList.published_at).format('YYYY/MM/DD') }}</span>
                    </h5>
                    <h5>
                      <!-- <span v-if="dataType === 'MAGAZINE' || (dataType === 'PLAN' && selectedPlan)">售價：</span>
                      <span v-if="dataType === 'BOOK' || dataType === 'PACKAGE' || dataType === 'ITEM'" class="originPrize">原價：</span> -->
                      <span>定價</span>

                      <span class="originPrize text-NotoSansRegular mr-1" v-if="dataType !== 'PLAN'">{{ Number(dataList.fixed_price).toLocaleString() }}元</span>
                      <span class="originPrize text-NotoSansRegular mr-1" v-if="dataType === 'PLAN' && selectedPlan && subscriberStatus.isPurshasePen && dataList.livepen">{{ (Number(selectedPlan.fixed_price) + Number(dataList.livepen.price)).toLocaleString() }}元</span>
                      <span class="originPrize text-NotoSansRegular mr-1" v-if="dataType === 'PLAN' && selectedPlan && !subscriberStatus.isPurshasePen">{{ Number(selectedPlan.fixed_price).toLocaleString() }}元</span>
                      <span class="mr-1 textColorRed font-semibold text-NotoSansBold" v-if="dataType !== 'PLAN' && dataList.display_discount">
                        {{ dataList.display_discount }}折</span>

                      <span class="text-NotoSansRegular" v-if="dataType !== 'PLAN' || (dataType === 'PLAN' && selectedPlan)">特價：</span>
                      <span class="newPrize text-NotoSansBold font-bold text-NotoSansBold" v-if="dataType !== 'PLAN'">{{ Number(dataList.pricing).toLocaleString() }}元</span>
                      <span class="newPrize text-NotoSansBold font-bold text-NotoSansBold" v-if="dataType === 'PLAN' && selectedPlan && subscriberStatus.isPurshasePen">{{ (Number(selectedPlan.pricing) + Number(dataList.livepen.price)).toLocaleString() }}元</span>
                      <span class="newPrize text-NotoSansBold font-bold text-NotoSansBold" v-if="dataType === 'PLAN' && selectedPlan && !subscriberStatus.isPurshasePen">{{ Number(selectedPlan.pricing).toLocaleString() }}元</span>
                    </h5>
                    <div v-if="dataType === 'PLAN' && !selectedPlan.is_digital" class="my-2 pt-2 border-t">
                      <div class="shiping flex flex-nowrap text-NotoSansRegular font-semibold items-center">
                        <h5 class="whitespace-no-wrap font-semibold">寄送方式：</h5>
                        <div class="control-group flex items-center text-left">
                          <label class="control control--radio block relative cursor-pointer mr-4" for="project_ordinary">平信
                            <input type="radio" name="projectShipping" v-model="isRegisteredMail" :value="false" id="project_ordinary" />
                            <div class="control__indicator"></div>
                          </label>
                          <label class="control control--radio block relative cursor-pointer mr-4" for="project_registered">掛號
                            <input type="radio" name="projectShipping" v-model="isRegisteredMail" :value="true" id="project_registered" />
                            <div class="control__indicator"></div>
                          </label>
                        </div>
                        <!-- <div class="items-center ml-2"> -->
                          <p class="textColor-searchBar">(掛號費每期20元)</p>
                        <!-- </div> -->

                      </div>
                      <!-- <p class="text-sm text-right px-3 md:hidden textColorRed">(掛號費每期20元)</p> -->
                    </div>
                    <div class="purshase flex flex-wrap text-NotoSansRegular my-2 items-center font-semibold pb-2 border-b"
                      v-if="dataType === 'PLAN' && dataList.livepen">
                      <!-- <h5 class="whitespace-no-wrap md:hidden">${{ Number(dataList.livepen.price) }}加購{{ dataList.livepen.name }}：</h5> -->
                      <h5 class="whitespace-no-wrap mb-2 md:mb-0">加購{{ dataList.livepen.name }} (請勾選)：</h5>
                      <div class="flex items-center">
                        <div>
                          <input class="styled-checkbox" id="styled-checkbox-2" type="checkbox" value="value2" v-model="subscriberStatus.isPurshasePen">
                          <label for="styled-checkbox-2">訂戶獨享優惠{{ Number(dataList.livepen.price) }}元</label>
                        </div>
                        <p class="textColor-searchBar ml-4">(定價2690元)</p>
                      </div>
                    </div>
                    <!-- 必送贈品/一般商品 -->
                    <!-- <div v-if="dataList.free_items && dataList.free_items.length > 0 && dataType !== 'PLAN'" class="md:mt-2 text-pinky">
                      <h5 class="whitespace-pre-wrap font-normal text-NotoSansRegular leading-loose" v-for="(item, index) in dataList.free_items" :key="index">
                        <span :class="{ freegiftsTitle: index > 0 }">贈品：</span>
                        <span class="text-NotoSansLight">{{ dataList.free_items[index].name }}</span>
                      </h5>
                    </div> -->
                    <!-- 必送贈品/訂閱 -->
                    <!-- <div v-if="selectedPlan.free_items && selectedPlan.free_items.length > 0 && dataType === 'PLAN'" class="md:mt-2 text-pinky">
                      <h5 class="whitespace-no-wrap font-normal text-NotoSansRegular leading-loose" v-for="(item, index) in selectedPlan.free_items" :key="index">
                        <span :class="{ freegiftsTitle: index > 0 }">贈品：</span>
                        <span class="text-NotoSansLight">{{ selectedPlan.free_items[index].name }}</span>
                      </h5>
                    </div> -->
                  </div>
                </div>
              </div>
              <!-- 庫存/購買 -->
              <div class="md:mt-1">
                <div class="buyBtn flex mt-2 md:items-center flex-wrap">

                  <!-- <p class="text-NotoSansRegular text-sm textColorRed whitespace-no-wrap w-full md:w-auto"
                    v-if="dataList.status !== 'DISCONTINUED' && dataList.category_id !== 114">
                    <span class="pr-3 md:pr-2" v-if="dataList.in_stock > 0">※有庫存</span>
                    <span class="pr-3 md:pr-2" v-if="dataList.in_stock === 0 || dataList.in_stock === null">※補貨中，暫時無法購買。</span>
                  </p> -->

                  <div class="flex flex-wrap w-full md:w-auto" v-if="dataList.status !== 'DISCONTINUED' && dataList.category_id !== 114">
                    <a v-if="dataList.status === 'DISCONTINUED'" class="w-full md:w-auto btn cannotbuyBtn cursor-default font-normal text-NotoSansRegular m-2 sm:mb-0 text-center"
                      >※已絕版 無法購買</a>

                    <a v-if="dataList.status !== 'DISCONTINUED' && dataList.in_stock > 0"
                      class="w-full md:w-auto btn cursor-pointer addCart addCartBtn font-normal text-NotoSansRegular m-2 lg:m-1 text-center whitespace-no-wrap hover:opacity-75"
                      @click.prevent="addCart()">加入購物車
                    </a>

                    <a v-if="(dataList.status !== 'DISCONTINUED' && dataList.in_stock > 0) && (additionalForSubscribers.indexOf(dataList.id.toString()) === -1 && dataList.name.indexOf('續訂') === -1)"
                      class="w-full md:w-auto btn cursor-pointer addCart insBuyBtn font-normal text-NotoSansRegular m-2 lg:m-1 text-center whitespace-no-wrap hover:opacity-75"
                      @click.prevent="checkoutNow">立即結帳
                    </a>

                    <a v-if="dataList.status !== 'DISCONTINUED' && !dataList.is_favorite" @click="addWish(dataList.id)"
                      class="w-full md:w-auto btn addWishBtn cursor-pointer font-normal text-NotoSansRegular text-center whitespace-no-wrap m-2 lg:m-1 hover:opacity-75"
                      :class="{ isFavorite: dataList.is_favorite }"
                      >加入收藏
                    </a>

                    <a v-if="dataList.status !== 'DISCONTINUED' && dataList.is_favorite"
                      class="w-full md:w-auto isFavorite btn addWishBtn cursor-pointer font-normal text-NotoSansRegular text-center whitespace-no-wrap m-2 lg:m-1"
                      disabled
                      >加入收藏
                    </a>
                  </div>
                  <div class="w-full text-sm" v-if="dataList.status === 'DISCONTINUED' && dataList.category_id === 114">
                    <p>校園團購用書，如需購買請洽詢：</p>
                    <div class="flex flex-wrap w-full text-sm">
                      <div class="w-full md:w-1/2">雙北、基、桃、宜、花、東、金：</div>
                      <div class="w-full md:w-1/2">02-2660-0608*207</div>
                      <div class="w-full md:w-1/2">竹、苗：</div>
                      <div class="w-full md:w-1/2">03-562-6866</div>
                      <div class="w-full md:w-1/2">中、彰、投、雲、嘉、澎：</div>
                      <div class="w-full md:w-1/2">04-2249-1588*22</div>
                      <div class="w-full md:w-1/2">南、高、屏：</div>
                      <div class="w-full md:w-1/2">07-236-0227</div>
                    </div>
                  </div>

                  <a v-if="(dataList.status === 'DISCONTINUED' || (selectedPlan && selectedPlan.status === 'DISCONTINUED' && selectedPlan.type === 'SUBSCRIPTION')) && dataList.category_id !== 114"
                    class="w-full md:w-auto btn addWishBtn cursor-pointer font-normal text-NotoSansRegular text-center whitespace-no-wrap"
                    >產品已停售
                  </a>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 贈品 -->
      <FreeGift
        v-if="freeGift_num > 0"
        :planGifts="freeGift_data"
        :gift_num="freeGift_num"
        v-on:getSelectGift="getSelectGift" />

      <hr class="my-4 mx-auto block" v-if="freeGift_num > 0">

      <div class="goodDetail" v-if="(downloadFiles.lifePenFile && downloadFiles.lifePenFile.length > 0) || (downloadFiles.myVoiceFile && downloadFiles.myVoiceFile.length > 0) || (downloadFiles.Mp3File && downloadFiles.Mp3File.length > 0) || (downloadFiles.uploadFile && downloadFiles.uploadFile.length > 0)">
        <h5 class="goodTitle w-full bg-gray-400 px-5 md:px-10 pt-3 pb-3 text-NotoSansBold">檔案下載</h5>
          <div class="goodText py-5 px-3 border-l border-r border-b font-normal text-NotoSansRegular textColorBlack">
            <DownloadFileBtns :downloadFiles="downloadFiles" :dataId="dataList.id" :category_id="dataList.category_id" />
          </div>
      </div>
      <!-- 商品詳情 -->
      <div class="goodDetail" v-if="dataList.description !== ''">
        <h5 class="goodTitle w-full bg-gray-400 px-5 md:px-10 pt-3 pb-3 text-NotoSansBold">商品詳情</h5>
        <div class="goodText py-5 px-4 md:px-8 border-l border-r border-b font-normal text-NotoSansRegular textColorBlack"
          v-html="dataList.description">

        </div>
      </div>

      <!-- 產品規格 -->
      <!-- <div class="goodDetail" v-if="dataType !== 'MAGAZINE' && dataType !== 'PLAN' && dataType !== 'PACKAGE'">
        <h5 class="goodTitle w-full bg-gray-400 px-5 md:px-10 pt-3 pb-3 text-NotoSansBold">產品規格</h5>
        <div class="goodText py-5 px-3 border-l border-r border-b font-normal text-NotoSansRegular textColorBlack">
          <p v-if="dataType !== 'ITEM'">規格: {{ dataList.specification }}</p>
          <p v-if="dataType !== 'PLAN'">料號: {{ dataList.serial_no }}</p>
        </div>
      </div> -->
    </div>
    <div v-else>
      <div class="hidden md:block">
        <vue-content-loading :width="300" :height="400">
          <rect cx="30" cy="30" width="100" r="30" height="120" x="0" />

          <rect cx="30" cy="80" r="50" x="110" y="0" rx="3" ry="3" width="140" height="8" />
          <rect x="110" y="20" rx="3" ry="3" width="100" height="8" />
          <rect x="110" y="40" rx="3" ry="3" width="150" height="8" />
          <rect x="110" y="60" rx="3" ry="3" width="100" height="8" />
          <rect x="110" y="80" rx="3" ry="3" width="150" height="8" />

          <rect x="120" y="140" r="10" ry="10" width="50" height="15" />
          <rect x="180" y="140" r="10" ry="10" width="50" height="15" />

          <rect x="0" y="130" rx="3" ry="3" width="100" height="30" />

          <rect x="0" y="170" rx="3" ry="3" width="300" height="10" />
          <rect x="0" y="190" rx="3" ry="3" width="300" height="10" />
          <rect x="0" y="210" rx="3" ry="3" width="300" height="10" />
          <rect x="0" y="230" rx="3" ry="3" width="300" height="10" />
          <rect x="0" y="250" rx="3" ry="3" width="300" height="10" />
        </vue-content-loading>
      </div>
      <div class="md:hidden">
        <vue-content-loading :width="300" :height="500">
          <rect cx="30" cy="30" width="200" r="30" height="200" x="50" />
          <rect cx="30" cy="80" r="50" x="50" y="210" rx="3" ry="3" width="200" height="10" />
          <rect x="50" y="230" rx="3" ry="3" width="200" height="10" />
          <rect x="10" y="250" r="10" ry="10" width="270" height="20" />
          <rect x="10" y="280" r="10" ry="10" width="270" height="20" />
          <rect x="10" y="310" r="10" ry="10" width="270" height="20" />
          <rect x="10" y="340" r="10" ry="10" width="270" height="20" />
          <rect x="10" y="370" r="10" ry="10" width="270" height="20" />
          <rect x="10" y="400" r="10" ry="10" width="270" height="20" />
          <rect x="10" y="430" r="10" ry="10" width="270" height="20" />
        </vue-content-loading>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-unneeded-ternary */
/* eslint-disable no-unused-expressions */
import Gallery from '@/components/product/Gallery'
import axios from 'axios'
import Cart from '@/components/modules/addCart'
import { mapGetters } from 'vuex'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import moment from 'moment'
import VueContentLoading from 'vue-content-loading'
import FreeGift from '@/components/product/FreeGift'
import SubscriberID from '@/components/product/SubscriberID'
import Breadcrumb from '@/components/product/Breadcrumb'
import DownloadFileBtns from '@/components/product/DownloadFileBtns'
import Bus from '@/components/modules/bus.js'
import advertising from '@/components/modules/advertising'
import sweetAlert from '@/components/modules/sweetAlert'
import jump from 'jump.js'
import ga4 from '@/components/modules/ga4'
export default {
  name: 'Content',
  metaInfo () {
    return {
      title: this.dataList ? this.dataList.name : '',
      meta: [
        { vmid: 'title', property: 'og:title', content: this.dataList ? this.dataList.name : '' },
        { vmid: 'description', name: 'description', content: this.dataList ? this.dataList.shortDesc : '' },
        { vmid: 'og:description', property: 'og:description', content: this.dataList ? this.dataList.shortDesc : '' },
        { vmid: 'url', property: 'og:url', content: 'https://store.liveabc.com' + this.$route.path },
        { vmid: 'type', property: 'og:type', content: 'product.item' },
        { vmid: 'image', roperty: 'og:image', itemprop: 'image', content: this.dataList ? this.dataList.cover : '' }
      ]
    }
  },
  data () {
    return {
      category_type: null,
      dataList: null,

      selectedPlan: '',

      // gift
      selectedGift: '',

      // 運送方式
      isRegisteredMail: false,

      // 起訖日期
      disabledDate (date) {
        // 當月，往後12個月
        // 2024/4/30行銷部要求修改
        return date < new Date().setMonth(new Date().getMonth() - 1) || date > new Date().setMonth(new Date().getMonth() + 12)
      },

      begin_at: null,
      end_at: null,

      downloadFiles: {
        lifePenFile: null,
        myVoiceFile: null,
        Mp3File: null,
        JLPTFile: null,
        uploadFile: null
      },

      // 驗證訂戶編號popup
      subscriberStatus: {
        isShow: false,
        isVerify: false,

        // 加購點讀筆
        isPurshasePen: false
      },
      purchasePenData: null,
      all_events: null,

      // 限雜誌訂戶加購
      additionalForSubscribers: ['6743', '8848', '7944', '11175', '11174']
    }
  },

  mixins: [
    Cart,
    advertising,
    ga4,
    sweetAlert
  ],
  watch: {
    '$route' (to, from) {
      if (to.params.id !== from.params.id) {
        this.getData()
      }
    }
  },
  components: {
    DatePicker,
    VueContentLoading,
    FreeGift,
    SubscriberID,
    Gallery,
    Breadcrumb,
    DownloadFileBtns
  },

  computed: {
    ...mapGetters([
      'userRole',
      'authorized'
    ]),

    dataType () {
      let self = this
      if (self.dataList !== null) {
        return self.dataList.type
      } else {
        return null
      }
    },

    previewList () {
      let self = this
      let coverList = self.dataList.attaches.filter(item => item.type === 'COVER')

      let sortData = self.dataList.attaches.filter(item => item.type === 'PREVIEW')
      let sortDatas = sortData.sort(self.compare('sort'))
      return coverList.concat(sortDatas)
    },

    freeGift_data () {
      if (this.dataType === 'PLAN' && this.selectedPlan && this.selectedPlan.free_gifts && this.selectedPlan.free_gifts.length > 0) {
        return this.selectedPlan.free_gifts
      } else if (this.dataType !== 'PLAN' && this.dataList.free_gifts && this.dataList.free_gifts.length > 0) {
        return this.dataList.free_gifts
      } else {
        return []
      }
    },

    freeGift_num () {
      if (this.dataType === 'PLAN' && this.selectedPlan && this.selectedPlan.free_gifts && this.selectedPlan.free_gifts.length > 0) {
        return this.selectedPlan.gift_num
      } else if (this.dataList.free_gifts && this.dataList.free_gifts.length > 0) {
        return this.dataList.gift_num
      } else {
        return 0
      }
    },

    magParams () {
      if (this.dataList.type === 'PLAN') {
        return 'MAGAZINE'
      } else {
        return this.dataList.type
      }
    }
  },
  created () {
  },
  mounted () {
    this.getData()
    this.getEvents()
    jump(this.$refs.BooksInner, {
      duration: 0,
      offset: 0
    })
  },

  methods: {
    getData () {
      let self = this
      var bookPath
      if ((self.$route.name === 'previewBook' || self.$route.name === 'previewMagazine' || self.$route.name === 'previewPackage') && self.userRole === 'admin') {
        bookPath = `/product/${self.$route.params.id}?scope=preview`
      } else {
        bookPath = `/product/${self.$route.params.id}?scope=onSale`
      }

      axios.get(bookPath)
        .then((response) => {
          if (response.status === 200) {
            Bus.$emit('val', response.data.type)
            self.dataList = response.data
            response.data.type === 'PLAN' ? self.selectedPlan = response.data.plan[0] : self.selectedPlan = ''

            self.downloadFiles.lifePenFile = self.dataList.attaches.filter(item => item.type === 'LIVEPEN_FILE')
            self.downloadFiles.myVoiceFile = self.dataList.attaches.filter(item => item.type === 'LIVEPEN_FILE_2')
            self.downloadFiles.Mp3File = self.dataList.attaches.filter(item => item.type === 'MP3')
            self.downloadFiles.uploadFile = self.dataList.attaches.filter(item => item.type === 'CONTENT_UPDATE')
            self.downloadFiles.JLPTFile = self.dataList.attaches.filter(item => item.type === 'JLPT_TEST')

            if (response.data.type === 'PLAN' && self.dataList.livepen && self.dataList.livepen.id) {
              self.getPenData()
            }

            self.getCategoryType()

            // 廣告商code
            self.setAdvertiserFunc(response.data.id, response.data.pricing)

            // ga4
            self.view_item(response.data)
          } else if (response.status === 404) {
            self.$router.push({ name: 'index' })
            self.alertPop('warning', '查無商品或商品已下架')
          }
        })
        .catch(() => {
          self.$router.push({ name: 'index' })
          self.alertPop('warning', '查無商品或商品已下架')
        })
    },
    getCategoryType () {
      axios.get(`/menu/${this.dataList.category_id}`)
        .then((response) => {
          this.category_type = response.data.type
        })
    },
    setAdvertiserFunc (id, pricing) {
      let self = this

      let newPricing = pricing ? pricing : 0
      self.likeProductCode(id, newPricing)
    },
    getEvents () {
      let self = this
      axios.get('/promote_events?type=all')
        .then((response) => {
          self.all_events = response.data.data
        })
    },
    getPenData () {
      let self = this
      axios.get(`/product/${self.dataList.livepen.id}?scope=onSale`)
        .then((response) => {
          self.purchasePenData = response.data
        })
    },
    getEndTime () {
      let self = this
      if (self.selectedPlan.months) {
        let months = self.selectedPlan.months - 1
        if (self.begin_at) {
          let startDate = new Date(self.begin_at)
          let endDateMoment = moment(startDate).add(months, 'months')
          self.end_at = moment(endDateMoment).format('YYYY-MM')
        } else {
          self.end_at = null
        }
      }
    },
    compare (attr) {
      return function (a, b) {
        return a.sort > b.sort || a.type > b.type ? 1 : -1
      }
    },

    getSelectGift (getSelectGift) {
      this.selectedGift = getSelectGift
    },
    async addWish (id) {
      let self = this
      let wishData = { 'productID': id, 'unit': '1' }
      if (self.$store.state.auth.authorized) {
        self.$set(self.dataList, 'is_favorite', true)

        axios.post(`/products/${id}/favorite`)
          .then(() => {
            self.getData()

            // 廣告商code
            self.dataType !== 'PLAN' ? wishData.price = self.dataList.pricing : null
            self.dataType === 'PLAN' ? wishData.price = self.selectedPlan.pricing : null

            self.addWishCode(wishData)

            // ga4
            self.add_to_wishlist(self.dataList)
          })

        self.$store.dispatch('isAddingWish', true)
      } else {
        self.alertPop('warning', '尚未登入')
      }
    },
    addCart () {
      // 加入購物車
      let self = this

      if (self.dataType === 'PLAN') {
        if (!self.begin_at || !self.end_at) {
          self.alertPop('warning', '尚未選擇起始日期')
        } else if (self.selectedGift.length !== self.selectedPlan.gift_num) {
          self.alertPop('warning', '尚未選擇贈品')
        } else if (self.selectedPlan !== '' && self.begin_at && self.end_at && self.selectedGift.length === self.selectedPlan.gift_num) {
          self.selectedPlan.link_id = self.dataList.id
          self.selectedPlan.link_name = self.dataList.name
          self.selectedPlan.begin_at = self.begin_at
          self.selectedPlan.end_at = self.end_at
          self.selectedPlan.selected_gifts = self.selectedGift

          // 數位板不給掛號費
          if (self.selectedPlan.is_digital) {
            self.selectedPlan.isRegisteredMail = false
          } else {
            self.selectedPlan.isRegisteredMail = self.isRegisteredMail
          }

          // 續訂方案檢查訂戶ID
          if (self.selectedPlan.name.indexOf('續訂') > -1 && !self.subscriberStatus.isVerify) {
            self.subscriberStatus.isShow = true
          } else {
            // 新訂戶
            self.addShoppingList(self.selectedPlan)
            self.addCartCode({ 'productID': self.selectedPlan.id, 'unit': '1', 'price': self.selectedPlan.pricing })
          }

          // 加購點讀筆&HIW不加價
          if (self.subscriberStatus.isPurshasePen) {
            self.extraPurchase()
          }
        }
      } else if (self.dataType !== 'PLAN') {
        if (self.additionalForSubscribers.indexOf(self.dataList.id.toString()) > -1 && !self.subscriberStatus.isVerify) {
          // 續訂戶點讀筆需驗證
          self.subscriberStatus.isShow = true
        } else {
          if (self.dataList.gift_num === 0) {
            // 不需要選贈品
            self.addShoppingList(self.dataList)
            self.addCartCode({ 'productID': self.dataList.id, 'unit': '1', 'price': self.dataList.pricing })
          } else if (self.dataList.gift_num > 0 && (self.selectedGift.length !== self.dataList.gift_num)) {
            // 有贈品沒選
            self.alertPop('warning', '尚未選擇贈品')
          } else if (self.dataList.gift_num > 0 && (self.selectedGift.length === self.dataList.gift_num)) {
            // 選擇商品數量相符
            self.addShoppingList(self.dataList, self.selectedGift)
            self.addCartCode({ 'productID': self.dataList.id, 'unit': '1', 'price': self.dataList.pricing })
          }
        }
      }
    },
    async checkoutNow () {
      // 立即結帳
      let self = this
      await self.addCart()
      self.$store.dispatch('routeRecord', { routeName: 'checkout' })

      if ((self.dataType !== 'PLAN' && self.dataList.gift_num === 0) || (self.dataType !== 'PLAN' && (self.dataList.gift_num > 0 && (self.selectedGift.length === self.dataList.gift_num))) || (self.dataType === 'PLAN' && self.selectedPlan !== '' && self.begin_at && self.end_at && self.selectedGift.length === self.selectedPlan.gift_num)) {
        if (!self.authorized) {
          self.$router.push({ name: 'login' })
        } else {
          await self.$store.dispatch('getProfile')
          self.$router.push({ name: 'checkout' })
        }
      }
    },
    closeSubscribe (closeSubscribe) {
      // 關閉詢問框
      let self = this
      self.subscriberStatus.isShow = false
      self.subscriberStatus.isAskShow = false
    },
    verifySubscribe (verifySubscribe) {
      // 訂戶編號詢問
      let self = this
      self.subscriberStatus.isVerify = verifySubscribe

      verifySubscribe ? self.addCart() : null
    },
    async extraPurchase () {
      // 加購點讀筆
      let self = this
      self.addShoppingList(self.purchasePenData)
    }
  }
}
</script>
<style lang="scss">
$mark-warning: #f5f5b3;
.ytp-cued-thumbnail-overlay-image {
  background-size: contain !important;
}
mark {
  background-color: transparent;
  padding: 2px 1px;
  border-radius: 5px;
  color: #e60012;
  &.warning {
    background: linear-gradient(transparent 40%, rgba(255,255,255,0) 50%,  $mark-warning  75%, $mark-warning 90%, transparent 95%);
  }
}

.freegiftsTitle {
  opacity: 0;
}
.BooksInner {
  .main {
    .playerIcon {
      top: 50%;
      transform: translateY(-50%);
      ul {
        li {
          a {
            width: 90px;
            height: 90px;
          }
        }
      }
    }
    .cover {
      position: relative;
      width: 100%;
      padding-bottom : 100%;
      background-position: center center;
      background-repeat: no-repeat;
      background-size: cover;
      background-color: white;
      .square-img {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        padding-bottom : 100%;
        background-position: center center;
        background-repeat: no-repeat;
        background-size: contain;
      }
      .square-img-none {
        background-image: url('~@/assets/images/preset_item.png');
      }
    }
    .SubscriptionPlan {
      .magazineLogo {
        img {
          max-width: 190px;
        }
      }
      h1 {
        color: #434343;
      }
    }
    .SubscriptionDetail {
      .startEndTime {
        .startTime {
          width: 46%;
        }
        .endTime {
          width: 46%;
        }
      }
      h5 {
        line-height: 2.2rem;
        font-size: 15px;
        @media (max-width: 769px) {
          line-height: 2rem;
        }
      }

      .radio-switch {
        input {
          position: absolute;
          visibility: hidden;
        }
        label {
          background-color: #ffffff;
          border-radius: 15px;
          border: 1px solid #e60012;
          font-size: 14px;
          font-weight: 500;
          margin: 0;
          transition: background-color .2s ease;
          margin-right: .2em;
          margin-left: .2em;
          color: #434343;
          font-weight: 400;
          &:hover {
            background-color: #e60012;
            color: white;
            cursor: pointer;
          }
        }
        input:checked + label {
          background-color: #e60012;
          color: white;
        }
      }
      .label-grop {
        h5 {
          line-height: 1.5rem;
          font-size: 14px;
        }
      }
      .activity {
        h5, p {
          line-height: 1.5rem;
          font-size: 14px;
        }
      }
      .originPrize {
        text-decoration:line-through;
        color: #434343;
        font-size: 14px;
      }
      .newPrize {
        color: #e60012;
        font-size: 2em;
        font-weight: 700;
        @media (max-width: 769px) {
          font-size: 1.8em;
        }
      }

    }
    .buyBtn {
      .btn {
        color: #ffffff;
        font-size: 16px;
        padding: .5em 1.8em;
        border-radius: 5px;
        // margin: 0 .4rem;
        @media (max-width: 1024px) {
          // font-size: 14px;
          padding: .6em 1.8em;
        }
      }
      .addCartBtn {
        background-color: #D80303;
        color: #ffffff;
      }
      .insBuyBtn {
        background-color: #219653;
        color: #ffffff;
      }
      .addWishBtn {
        background-color: #BDBDBD;
        color: #ffffff;
      }
      .cannotbuyBtn {
        background-color: #e5e5e5;
        color: #5d5d5d;
      }
      .chooseBtn {
        width: 120px;
        height: 38px;
        background-color: white;
        border: 1px solid #e60012;
        color: #e60012;
        font-size: 14px;
        margin: 0 .2rem;
        position: relative;
        span {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          white-space: nowrap;
        }
        &:active {
          span {
            transform: translate(-50%, -45%);
          }
        }
      }
      .isFavorite {
        background-color: #e60012;
        color: white;
        cursor: default !important;
      }
    }
    .input-class {
      display: inline-block;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      width: 100%;
      height: 38px;
      padding-left: 0.5rem;
      font-size: 14px;
      line-height: 1.4;
      color: #555;
      background-color: #fff;
      border: 1px solid #a0aec0;
      border-radius: 4px;
      -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075);
      box-shadow: inset 0 1px 1px rgba(0,0,0,.075);
    }
  }
  .goodDetail {
    .goodTitle {
      h5 {
        font-weight: 700;
        font-size: 16px;
        color: #434343;
      }
    }
    .goodText {
      font-weight: 400;
      font-size: 16px !important;
      line-height: 24px;
      letter-spacing: 3px;
      img {
        object-fit: contain;
        max-width: 100%;
      }
      a {
        text-decoration: underline;
        color: rgb(78, 78, 247);
      }
      iframe {
        @media (max-width: 769px) {
          width: 100%;
        }
      }
    }
  }
  hr {
    border-style: inset;
    border-width: 1px;
  }
}
.styled-checkbox {
  position: absolute; // take it out of document flow
  opacity: 0; // hide it

  & + label {
    position: relative;
    cursor: pointer;
    padding: 0;
  }
  // Box.
  & + label:before {
    content: '';
    margin-right: 10px;
    display: inline-block;
    vertical-align: text-top;
    width: 20px;
    height: 20px;
    background: white;
    border: 1px solid #CCCCCC;
  }
  // Box hover
  &:hover + label:before {
    background: #D80303;
  }
  // Box focus
  &:focus + label:before {
    box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.12);
  }
  // Box checked
  &:checked + label:before {
    background: #D80303;
  }
  // Disabled state label.
  &:disabled + label {
    color: #b8b8b8;
    cursor: auto;
  }

  // Disabled box.
  &:disabled + label:before {
    box-shadow: none;
    background: #ddd;
  }

  // Checkmark. Could be replaced with an image
  &:checked + label:after {
    content: '';
    position: absolute;
    left: 5px;
    top: 9px;
    background: white;
    width: 2px;
    height: 2px;
    box-shadow:
      2px 0 0 white,
      4px 0 0 white,
      4px -2px 0 white,
      4px -4px 0 white,
      4px -6px 0 white,
      4px -8px 0 white;
    transform: rotate(45deg);
  }
}
// radio
.control {
  display: block;
  position: relative;
  padding-left: 25px;
  cursor: pointer;
}
.control input {
  position: absolute;
  z-index: -1;
  opacity: 0;
}
.control--radio .control__indicator {
  border-radius: 50%;
}
.control__indicator {
  position: absolute;
  top: 2px;
  left: 0;
  height: 20px;
  width: 20px;
  border: 2px solid #CCCCCC;
}
.control input:checked ~ .control__indicator:after {
  display: block;
}
.control--radio .control__indicator:after {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  height: 15px;
  width: 15px;
  border-radius: 50%;
  background: #D80303;
}
.control__indicator:after {
  content: '';
  position: absolute;
  display: none;
}
</style>
